// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---------- Input Row Header (input + info icon) ---------- */
.appStyle_inputHeaderRow__GZLhK {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.appStyle_inputHeaderRow__GZLhK .appStyle_message_input_box__RqzO- {
  flex: 1 1;
}

/* ---------- Coming Soon Badge ---------- */
.appStyle_comingSoonBadge__S-kF0 {
  display: inline-block;
  margin-left: 10px;
  padding: 2px 10px;
  font-size: 11px;
  font-weight: 600;
  color: #92400e;
  background: #fef3c7;
  border: 1px solid #fcd34d;
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  vertical-align: middle;
  animation: appStyle_subtlePulse__88Aae 2s ease-in-out infinite;
}

@keyframes appStyle_subtlePulse__88Aae {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

/* ---------- Disabled Button State ---------- */
.appStyle_resetBtn__1XXUh:disabled,
.appStyle_sendMsg__Ava2G:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* ---------- Info Modal (already in your file, kept for reference) ---------- */
.appStyle_modalOverlay__VJenO {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: appStyle_fadeIn__VC4-K 0.2s ease;
}

.appStyle_modal__0bN8s {
  background: white;
  border-radius: 12px;
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  position: relative;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  animation: appStyle_slideUp__wjFRa 0.3s ease;
}

.appStyle_closeButton__peMkR {
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  cursor: pointer;
  color: #94a3b8;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 18px;
  z-index: 10;
}

.appStyle_closeButton__peMkR:hover {
  background: #f1f5f9;
  color: #1a1a1a;
}

.appStyle_modalContent__GUE6E {
  padding: 24px 28px;
  overflow-y: auto;
  max-height: 85vh;
}

@keyframes appStyle_fadeIn__VC4-K {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes appStyle_slideUp__wjFRa {
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

/* Modal Styles */
.appStyle_modalOverlay__VJenO {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: appStyle_fadeIn__VC4-K 0.2s ease;
}

.appStyle_modal__0bN8s {
  background: white;
  border-radius: 12px;
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  position: relative;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  animation: appStyle_slideUp__wjFRa 0.3s ease;
}

.appStyle_closeButton__peMkR {
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  cursor: pointer;
  color: #94a3b8;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}

.appStyle_closeButton__peMkR:hover {
  background: #f1f5f9;
  color: #1a1a1a;
}

.appStyle_modalContent__GUE6E {
  padding: 24px 28px;
  overflow-y: auto;
  max-height: 85vh;
}

/* Animations */
@keyframes appStyle_fadeIn__VC4-K {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes appStyle_slideUp__wjFRa {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Suggestion Icon */
.appStyle_suggestion_icon__41mtO {
  color: #94a3b8;
  font-size: 16px;
  cursor: pointer;
  transition: color 0.2s;
  margin-left: 6px;
}

.appStyle_suggestion_icon__41mtO:hover {
  color: #3b82f6;
}

.appStyle_title_ic__BAe\\+e {
  display: flex;
  align-items: center;
  gap: 8px;
}

.appStyle_title_ic__BAe\\+e h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #0a0a0a;
}

/* Toggle Container */
.appStyle_toggleContainer__4vJu\\+ {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  /* padding: 12px 0; */
  border-bottom: 1px solid #e2e8f0;
  /* margin-bottom: 16px; */
  flex-direction: column-reverse;
  gap: 12px;
}

.appStyle_liveAgentToggle__8psFe {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: flex-end;
  width: 100%;
}

.appStyle_toggleText__ypSL7 {
  font-size: 16px;
  font-weight: 600;
  color: #495057;
  display: block;
  margin-bottom: 10px;
}

.appStyle_switchWrap__oYyha {
  display: flex;
  align-items: center;
  gap: 12px;
}

.appStyle_switch__aM2cr {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
}

.appStyle_switch__aM2cr input {
  opacity: 0;
  width: 0;
  height: 0;
}

.appStyle_slider__nMDhn {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: #cbd5e1;
  transition: 0.3s;
  border-radius: 24px;
}

.appStyle_slider__nMDhn::before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: transform 0.3s;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.appStyle_active__eNaNg {
  background-color: #3b82f6;
}

.appStyle_active__eNaNg::before {
  transform: translateX(20px);
}

.appStyle_bot-content-container__GUKBw {
  padding: 8px 0;
}


/* Add these to appStyle.module.css */
/* Add to appStyle.module.css */
.appStyle_dropdownSection__LHDar {
  margin-bottom: 20px;
  width: 100%;
}

.appStyle_dropdownHeader__8b4DP {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #e0e0e0;
  transition: all 0.3s ease;
}

.appStyle_dropdownHeader__8b4DP:hover {
  opacity: 0.8;
}

.appStyle_dropdownContent__guVYe {
  animation: appStyle_slideDown__cPnXs 0.3s ease;
}

@keyframes appStyle_slideDown__cPnXs {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.appStyle_controlGroup__iHpRw {
  margin-bottom: 10px;
  padding: 15px;
  background: #e6edff;
  border-radius: 6px;
  border: 1px solid #a3bdff;
}

.appStyle_controlLabel__QM4aE {
  display: flex;
  flex-direction: column-reverse;
}
.appStyle_disabledMessage__eYrgf {
  margin: auto;
  margin-bottom: 20px;
}
.appStyle_labelText__8yoW\\+ {
  font-size: 16px;
  font-weight: 600;
  color: #0a0a0a;
}

.appStyle_toggleLabel__YuDOw {
  font-size: 14px;
  color: #495057;
  font-weight: 500;
}

.appStyle_toggleSwitch__fymGA {
  width: 50px;
  height: 24px;
  background-color: #ccc;
  border-radius: 12px;
  position: relative;
  cursor: pointer;
  transition: background-color 0.3s;
}

.appStyle_toggleOn__qHQW\\+ {
  background-color: var(--saveBtn);
}

.appStyle_toggleOff__ArqCq {
  background-color: #ccc;
}

.appStyle_toggleSlider__qF98n {
  width: 20px;
  height: 20px;
  background-color: var(--white-color);
  border-radius: 50%;
  position: absolute;
  top: 2px;
  transition: transform 0.3s;
}

.appStyle_toggleOn__qHQW\\+ .appStyle_toggleSlider__qF98n {
  transform: translateX(26px);
}

.appStyle_toggleOff__ArqCq .appStyle_toggleSlider__qF98n {
  transform: translateX(2px);
}

.appStyle_helperText__m9xcb {
  font-size: 13px;
  color: #6c757d;
  margin: 5px 0 0 0;
  font-style: italic;
}

/* In your appStyle.module.css */
.appStyle_duplicate-url__Of3gN {
  border: 2px solid #ffa500 !important;
  background-color: #fff9e6 !important;
}

.appStyle_duplicate-warning__zogoz {
  color: #ffa500;
  font-size: 0.8rem;
  font-style: italic;
  margin-top: 4px;
}

.appStyle_ingested-urls-list__cChkS {
  margin-top: 15px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 15px;
  background: #f8f9fa;
  max-height: 300px;
  overflow-y: auto;
}

.appStyle_ingested-urls-header__reFcl {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.appStyle_ingested-urls-header__reFcl h5 {
  margin: 0;
  font-size: 14px;
  color: #495057;
  font-weight: 600;
}

.appStyle_show-all-button__vJEIZ {
  background: #007bff;
  color: white;
  border: none;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.appStyle_show-all-button__vJEIZ:hover {
  background: #0056b3;
}

.appStyle_ingested-urls-list__cChkS ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.appStyle_ingested-url-item__yPsX\\+ {
  display: flex;
  align-items: flex-start;
  padding: 8px 0;
  border-bottom: 1px solid #e9ecef;
  font-size: 13px;
}

.appStyle_ingested-url-item__yPsX\\+:last-child {
  border-bottom: none;
}

.appStyle_url-number__MKoaG {
  min-width: 20px;
  color: #6c757d;
  font-weight: 500;
  margin-right: 8px;
}

.appStyle_url-text__\\+GiPG {
  word-break: break-all;
  color: #495057;
  line-height: 1.4;
}

.appStyle_more-urls-indicator__u1TNs {
  text-align: center;
  padding: 8px;
  color: #6c757d;
  font-size: 12px;
  font-style: italic;
  background: #e9ecef;
  border-radius: 4px;
  margin-top: 8px;
}

/* Scrollbar styling for the URLs list */
.appStyle_ingested-urls-list__cChkS::-webkit-scrollbar {
  width: 6px;
}

.appStyle_ingested-urls-list__cChkS::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.appStyle_ingested-urls-list__cChkS::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.appStyle_ingested-urls-list__cChkS::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.appStyle_nested-toggle__C\\+Ldx {
  margin-bottom: 15px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.appStyle_nested-toggle__C\\+Ldx label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  cursor: pointer;
}

.appStyle_help-text__wPUae {
  display: block;
  font-size: 12px;
  color: #6c757d;
  margin-top: 4px;
  margin-left: 24px;
}

.appStyle_ingested-urls-list__cChkS {
  margin-top: 15px;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 10px;
  background: #f8f9fa;
}

.appStyle_ingested-urls-list__cChkS h5 {
  margin: 0 0 10px 0;
  font-size: 14px;
  color: #495057;
}

.appStyle_ingested-urls-list__cChkS ul {
  margin: 0;
  padding-left: 20px;
}

.appStyle_ingested-urls-list__cChkS li {
  font-size: 12px;
  word-break: break-all;
  margin-bottom: 5px;
  color: #6c757d;
}
/* 
.wrap_welcome_message {
  width: 100%;
  padding: 4px 0;
  border-radius: 6px;
  background: #d5e9ff;
  border: 1px solid var(--primary);
  padding: 20px;
} */
.appStyle_wrap_welcome_message__7aSpf h3 {
  margin: 0 0 20px 0;
  color: var(--dark2-color);
  font-size: 1rem;
}
.appStyle_wrap_welcome_message__7aSpf p {
  color: var(--heading);
}
.appStyle_welcome_message__JOoR7 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 20px;
}
.appStyle_validationError__A7TzJ {
  border: 2px solid red !important;
}

/* Main container */
.appStyle_ai-agent-container__qK0sI {
  /* max-width: 800px; */
  margin: 20px auto;
  padding: 20px;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  text-align: center;
}
.appStyle_headings__gh9HX {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0;
  /* text-align: left; */
}
.appStyle_ai-agent-container__qK0sI h3 {
  margin-bottom: 20px;
  color: #353232;
}
.appStyle_ai-agent-container__qK0sI p {
  color: #666;
}

/* Method toggles */
.appStyle_ingestion-methods__8A5IF {
  display: flex;
  gap: 20px;
  margin: 30px auto;
  align-items: center;
  justify-content: center;
}

.appStyle_method-toggle__rZBOg {
  display: flex;
  align-items: center;
}

.appStyle_method-toggle__rZBOg label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.appStyle_method-toggle__rZBOg input[type="checkbox"] {
  width: 18px;
  height: 18px;
}

/* Ingestion sections */
.appStyle_ingestion-sections__5fP4q {
  display: flex;
  flex-direction: column;
  gap: 25px;
  margin-bottom: 30px;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.appStyle_ingestion-section__hSWoM {
  border: 1px solid #e1e5e9;
  padding: 20px;
  border-radius: 8px;
  background-color: #fafbfc;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 360px;
  max-width: 530px;
}

.appStyle_ingestion-section__hSWoM h4 {
  margin: 0 0 15px 0;
  color: #2d333a;
}

/* Input fields */
.appStyle_url-input__trckO,
.appStyle_file-input__-PqmL {
  width: 100%;
  padding: 10px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 14px;
  margin-bottom: 10px;
}

.appStyle_url-input__trckO:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* URL management */
.appStyle_url-row__Ggev2 {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  align-items: center;
  width: 100%;
}

.appStyle_url-row__Ggev2 .appStyle_url-input__trckO {
  flex: 1 1;
  margin-bottom: 0;
}

/* Buttons */
.appStyle_add-url-button__dUIBx,
.appStyle_remove-url-button__hy8mV,
.appStyle_ingest-all-button__45XSS {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}
.appStyle_add-url-button__dUIBx {
  background-color: #a370ce;
  color: white;
}

.appStyle_add-url-button__dUIBx:hover {
  background-color: #8859af;
}

.appStyle_remove-url-button__hy8mV {
  background-color: #fee2e2;
  color: #b91c1c;
  padding: 6px 12px;
}

.appStyle_remove-url-button__hy8mV:hover {
  background-color: #fecaca;
}

.appStyle_ingest-all-button__45XSS {
  padding: 10px 20px;
  background-color: #28a745;
  color: white;
  font-size: 1rem;
  border-radius: 6px;
  border: none;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.appStyle_ingest-all-button__45XSS:hover:not(:disabled) {
  background-color: #059669;
}

.appStyle_ingest-all-button__45XSS:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}

/* File upload */
.appStyle_file-input__-PqmL {
  display: none;
}

.appStyle_file-input-label__Lf\\+YU {
  display: inline-block;
  padding: 10px 16px;
  background-color: #f3f4f6;
  border: 1px dashed #6e6e6f;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.appStyle_file-input-label__Lf\\+YU:hover {
  background-color: #e5e7eb;
}
.appStyle_ingestion-section__hSWoM .appStyle_file-input-label__Lf\\+YU {
  width: 100%;
  max-width: 300px;
  text-align: center;
  color: #6e6e6f;
}
/* File list */
.appStyle_file-list__TC9\\+C {
  margin-top: 15px;
  border: 1px solid #bfbfbf;
  padding: 20px;
  border-radius: 8px;
  background: white;
  margin-top: 15px;
}

.appStyle_file-list__TC9\\+C ul {
  list-style: none;
  padding: 0;
  margin: 10px 0 0 0;
}

.appStyle_file-list__TC9\\+C li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid #e5e7eb;
}

.appStyle_remove-file-button__lqUDP {
  background: none;
  border: none;
  color: #ef4444;
  cursor: pointer;
  font-size: 12px;
  padding: 2px 6px;
}

/* Progress and messages */
.appStyle_progress__Oy9\\+X {
  color: #059669;
  font-size: 14px;
  margin-left: 10px;
  margin-top: 15px;
}

.appStyle_ingestion-message__DoPNR {
  padding: 12px;
  border-radius: 4px;
  margin: 20px 0;
  background-color: #fef3c7;
  color: #92400e;
  border: 1px solid #fcd34d;
}

.appStyle_success-message__6XKPn {
  color: #059669;
  font-weight: 500;
  margin: 20px 0;
}

/* Error states */
.appStyle_error-border__HInCw {
  border-color: #ef4444 !important;
}

/* Modal */
.appStyle_modal-overlay__zggQL {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.appStyle_modal__0bN8s {
  background: white;
  padding: 25px;
  border-radius: 8px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.appStyle_modal__0bN8s h3 {
  margin: 0 0 15px 0;
  color: #2d333a;
}

.appStyle_modal__0bN8s p {
  margin: 0 0 20px 0;
  color: #6b7280;
}

.appStyle_modal-buttons__DbMm5 {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.appStyle_cancel-button__Y0jxm,
.appStyle_confirm-button__XZKi3 {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.appStyle_cancel-button__Y0jxm {
  background-color: #f3f4f6;
  color: #374151;
}

.appStyle_cancel-button__Y0jxm:hover {
  background-color: #e5e7eb;
}

.appStyle_confirm-button__XZKi3 {
  background-color: #ef4444;
  color: white;
}

.appStyle_confirm-button__XZKi3:hover {
  background-color: #dc2626;
}

.appStyle_mesgWrapper__ANtNq {
  background-color: #e6edff;
  border: 1px solid #a3bdff;
  padding: 20px;
  border-radius: 8px;
  /* margin-top: 30px; */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.appStyle_message_wrapper__32bB3 {
  display: block;
  width: 100%;
}

.appStyle_message_input__rDkoj {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}
.appStyle_actions_leftWord_wrap__a5PI7 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row-reverse;
  width: 100%;
  margin-top: 5px;
}
/* .message_preview {
  background-color: rgb(243, 243, 243);
  width: 100%;
  padding: 8px;
  margin-top: 10px;
  max-height: 110px;
  overflow: auto;
} */

.appStyle_message_preview__maJAX p {
  color: #00796b;
  font-size: 16px;
}

.appStyle_message_input_box__RqzO- {
  width: 100%;
  border: none;
  border-bottom: 2px solid #e5e7eb;
  outline: none;
  padding: 5px 15px 15px 0;
  font-size: 14px;
  transition: border-color 0.3s ease;
  color: #374151;
}

.appStyle_message_input_box__RqzO-::placeholder {
  color: #9ca3af;
}

.appStyle_message_input_box__RqzO-:focus {
  border-bottom: 2px solid var(--primary);
  color: var(--text-color);
}

.appStyle_sendMsg__Ava2G,
.appStyle_resetBtn__1XXUh,
.appStyle_skipBtn__Wq-dG {
  border-radius: 5px;
  padding: 5px 10px;
  outline: none;
  background-color: transparent;
  font-size: 16px;
  border: none;
  cursor: pointer;
}
.appStyle_sendMsg__Ava2G {
  background: var(--primary);
  color: var(--white-color);
}
.appStyle_sendMsg__Ava2G:hover {
  background: var(--primary-hover);
}
.appStyle_resetBtn__1XXUh {
  background-color: var(--cancelBtn);
  color: var(--heading);
  margin-right: 10px;
}

/* AI Agent Ingestion Styles */
.appStyle_aiAgentContainer__wqLU5 {
  margin: 20px 0;
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #f9f9f9;
}

.appStyle_ingestionMethods__CIZmi {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 20px;
}

.appStyle_methodToggle__5eXUL {
  display: flex;
  align-items: center;
}

.appStyle_methodToggle__5eXUL label {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.appStyle_methodToggle__5eXUL input[type="checkbox"] {
  margin-right: 8px;
}

.appStyle_ingestionSections__rzZWa {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
}

.appStyle_ingestionSection__GJFHn {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.appStyle_ingestionSection__GJFHn:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.appStyle_ingestionSection__GJFHn h4 {
  margin-top: 0;
  margin-bottom: 10px;
  color: #333;
}

.appStyle_urlRow__hGkMm {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;
}

.appStyle_fileList__5w7BQ {
  margin-top: 15px;
}

.appStyle_fileList__5w7BQ ul {
  list-style: none;
  padding: 0;
}

.appStyle_fileList__5w7BQ li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  background-color: #f9f9f9;
  border-radius: 4px;
  margin-bottom: 8px;
}

.appStyle_fileInputLabel__PSUCs {
  display: block;
  padding: 10px 15px;
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 10px;
  text-align: center;
}

.appStyle_fileInputLabel__PSUCs:hover {
  background-color: #e0e0e0;
}

.appStyle_progress__Oy9\\+X {
  margin-left: 10px;
  font-size: 0.9em;
  color: #666;
}

.appStyle_ingestAllButton__yDGUA {
  background-color: var(--saveBtn);
  color: var(--white-color);
  border: none;
  padding: 12px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
}

.appStyle_ingestAllButton__yDGUA:hover:not(:disabled) {
  background-color: var(--saveHover);
}

.appStyle_ingestAllButton__yDGUA:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.appStyle_addUrlButton__0h6uW {
  background-color: var(--saveBtn);
  color: var(--white-color);
}

.appStyle_removeUrlButton__ZsAcd {
  background-color: #dc3545;
  color: white;
}

.appStyle_ingestionMessage__moULt {
  margin-top: 10px;
  padding: 10px;
  border-radius: 4px;
  background-color: #e9ecef;
}

.appStyle_toggleSection__JIDxH {
  display: flex;
  align-items: center;
  margin: 15px 0;
  gap: 10px;
}

.appStyle_suggestion_icon__41mtO {
  color: #94a3b8;
  font-size: 16px;
  cursor: pointer;
  transition: color 0.2s;
  margin-left: 6px;
}

.appStyle_suggestion_icon__41mtO:hover {
  color: #3b82f6;
}

.appStyle_title_ic__BAe\\+e {
  display: flex;
  align-items: center;
  gap: 8px;
}

.appStyle_title_ic__BAe\\+e h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #0a0a0a;
}

.appStyle_botContent_sections__Ef0tp {
  margin-bottom: 30px;
  padding: 15px;
  background: #e6edff;
  border-radius: 6px;
  border: 1px solid #a3bdff;
}
.appStyle_message_preview__maJAX h4 {
  font-size: 16px;
  font-weight: 500;
  font-style: italic;
  color: var(--dark-color);
  text-align: center;
  margin: 0 0 10px 0;
}

/* Toggle Switch Styles */
.appStyle_toggleSwitchContainer__qT7C5 {
  display: flex;
  align-items: center;
  /* margin-bottom: 15px; */
}

.appStyle_toggleSwitch__fymGA {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
  margin-right: 10px;
}

.appStyle_toggleSwitch__fymGA input {
  opacity: 0;
  width: 0;
  height: 0;
}

.appStyle_info-message__4y5aY {
  background-color: #e8f4fd;
  border: 1px solid #b6e0fe;
  border-radius: 4px;
  padding: 8px 12px;
  margin: 10px 0;
  font-size: 14px;
  color: #1e6fa3;
}

.appStyle_toggleSwitch__fymGA input:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
input:checked + .appStyle_toggleSlider__qF98n {
  background-color: #2196f3;
}

input:checked + .appStyle_toggleSlider__qF98n:before {
  transform: translateX(26px);
}

.appStyle_toggleLabel__YuDOw {
  font-weight: 500;
}

.appStyle_toggleWithLabel__Oe29r {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}

.appStyle_choose-option__3\\+Qmn {
  display: flex;
  margin-bottom: 30px;
  text-align: center;
  align-items: center;
  justify-content: center;
}

.appStyle_choose-option__3\\+Qmn label {
  font-size: 24px;
  font-weight: 600;
  color: var(--dark2-color);
  margin: 0;
}
.appStyle_refreshButton__RXsJN {
  margin-left: 10px;
  font-size: 0.8rem;
  background-color: var(--icon-bg-color);
  border-radius: 50%;
  cursor: pointer;
  width: 30px;
  height: 30px;
  color: #3f82ff;
  outline: none;
  border: none;
  font-size: 20px;
}
@media screen and (max-width: 1068px) {
  .appStyle_create_Container__cUCq\\+ {
    width: 95%;
    height: auto;
  }
  .appStyle_input-row__nyMrM {
    padding: 14px 12px;
    flex-wrap: wrap;
  }
  .appStyle_input-row__nyMrM label {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .appStyle_input-row__nyMrM label strong,
  .appStyle_input-row__nyMrM label p {
    white-space: normal;
  }
  .appStyle_wrap_welcome_message__7aSpf {
    flex-direction: column;
  }
}
@media screen and (max-width: 360px) {
  .appStyle_ingestion-section__hSWoM {
    width: 100%;
    min-width: 0px;
  }
  .appStyle_ingestion-methods__8A5IF {
    flex-direction: column;
    align-items: flex-start;
    margin: 15px 0px;
  }
  .appStyle_toggleWithLabel__Oe29r {
    margin-bottom: 20px;
  }
  .appStyle_welcome_message__JOoR7 {
    flex-direction: column;
    padding: 0px;
  }
  .appStyle_wrap_welcome_message__7aSpf {
    padding: 10px;
  }
  .appStyle_mesgWrapper__ANtNq {
    padding: 10px;
  }
  .appStyle_actions_leftWord_wrap__a5PI7 {
    flex-direction: column-reverse;
    gap: 20px;
    align-items: flex-start;
  }
  .appStyle_message_preview__maJAX {
    text-align: left;
  }
  .appStyle_message_preview__maJAX p {
    /* border: 1px solid red; */
    font-size: 12px;
  }
}
/* .toggleContainer {
  display: flex;
  width: 100%;
  flex-direction: column-reverse;
} */
.appStyle_titleSection__5L8mE {
  /* flex: 1 1; */
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;
  /* text-align: center; */
  flex-direction: column;
  width: 100%;
}

.appStyle_switch__aM2cr {
  flex-shrink: 0;
}

.appStyle_switch__aM2cr {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
}

.appStyle_switch__aM2cr input {
  opacity: 0;
  width: 0;
  height: 0;
}
.appStyle_toggleContainer__4vJu\\+ .appStyle_switchWrap__oYyha {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.appStyle_slider__nMDhn {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: #ccc;
  transition: 0.3s;
  border-radius: 24px;
}

.appStyle_slider__nMDhn::before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
}

.appStyle_switch__aM2cr input:checked + .appStyle_slider__nMDhn {
  background: var(--saveBtn);
}

.appStyle_switch__aM2cr input:checked + .appStyle_slider__nMDhn::before {
  transform: translateX(20px);
}

.appStyle_toggleText__ypSL7 {
  font-size: 14px;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/Component/app_components/appStyle.module.css"],"names":[],"mappings":"AAAA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,SAAO;AACT;;AAEA,4CAA4C;AAC5C;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,8DAA8C;AAChD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA,gDAAgD;AAChD;;EAEE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,gFAAgF;AAChF;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2CAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,4CAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2CAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,4CAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;EAChC,yBAAyB;EACzB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;;AAGA,qCAAqC;AACrC,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8CAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;AACA;;;;;;;;GAQG;AACH;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,SAAS;AACX;AACA;EACE,gCAAgC;AAClC;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb;uEACqE;EACrE,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;;EAEE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA,YAAY;AACZ;;;EAGE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA,cAAc;AACd;EACE,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,gCAAgC;AAClC;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;EAC3B,WAAW;EACX,eAAe;AACjB;AACA;;;;;;;GAOG;;AAEH;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,aAAa;EACb,wBAAwB;EACxB,eAAe;EACf,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;;;EAGE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;AACA;EACE;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,eAAe;IACf,2BAA2B;EAC7B;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,8BAA8B;IAC9B,SAAS;IACT,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,2BAA2B;IAC3B,eAAe;EACjB;AACF;AACA;;;;GAIG;AACH;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;EACR,wBAAwB;EACxB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;AACA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB","sourcesContent":["/* ---------- Input Row Header (input + info icon) ---------- */\n.inputHeaderRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n\n.inputHeaderRow .message_input_box {\n  flex: 1;\n}\n\n/* ---------- Coming Soon Badge ---------- */\n.comingSoonBadge {\n  display: inline-block;\n  margin-left: 10px;\n  padding: 2px 10px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #92400e;\n  background: #fef3c7;\n  border: 1px solid #fcd34d;\n  border-radius: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  vertical-align: middle;\n  animation: subtlePulse 2s ease-in-out infinite;\n}\n\n@keyframes subtlePulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.7; }\n}\n\n/* ---------- Disabled Button State ---------- */\n.resetBtn:disabled,\n.sendMsg:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* ---------- Info Modal (already in your file, kept for reference) ---------- */\n.modalOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: fadeIn 0.2s ease;\n}\n\n.modal {\n  background: white;\n  border-radius: 12px;\n  max-width: 600px;\n  width: 90%;\n  max-height: 90vh;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);\n  animation: slideUp 0.3s ease;\n}\n\n.closeButton {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #94a3b8;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 18px;\n  z-index: 10;\n}\n\n.closeButton:hover {\n  background: #f1f5f9;\n  color: #1a1a1a;\n}\n\n.modalContent {\n  padding: 24px 28px;\n  overflow-y: auto;\n  max-height: 85vh;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideUp {\n  from { transform: translateY(20px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n/* Modal Styles */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: fadeIn 0.2s ease;\n}\n\n.modal {\n  background: white;\n  border-radius: 12px;\n  max-width: 600px;\n  width: 90%;\n  max-height: 90vh;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);\n  animation: slideUp 0.3s ease;\n}\n\n.closeButton {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #94a3b8;\n  padding: 4px;\n  border-radius: 4px;\n  transition: all 0.2s;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.closeButton:hover {\n  background: #f1f5f9;\n  color: #1a1a1a;\n}\n\n.modalContent {\n  padding: 24px 28px;\n  overflow-y: auto;\n  max-height: 85vh;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* Suggestion Icon */\n.suggestion_icon {\n  color: #94a3b8;\n  font-size: 16px;\n  cursor: pointer;\n  transition: color 0.2s;\n  margin-left: 6px;\n}\n\n.suggestion_icon:hover {\n  color: #3b82f6;\n}\n\n.title_ic {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.title_ic h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #0a0a0a;\n}\n\n/* Toggle Container */\n.toggleContainer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  /* padding: 12px 0; */\n  border-bottom: 1px solid #e2e8f0;\n  /* margin-bottom: 16px; */\n  flex-direction: column-reverse;\n  gap: 12px;\n}\n\n.liveAgentToggle {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  justify-content: flex-end;\n  width: 100%;\n}\n\n.toggleText {\n  font-size: 16px;\n  font-weight: 600;\n  color: #495057;\n  display: block;\n  margin-bottom: 10px;\n}\n\n.switchWrap {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 44px;\n  height: 24px;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  inset: 0;\n  background-color: #cbd5e1;\n  transition: 0.3s;\n  border-radius: 24px;\n}\n\n.slider::before {\n  content: \"\";\n  position: absolute;\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: transform 0.3s;\n  border-radius: 50%;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.active {\n  background-color: #3b82f6;\n}\n\n.active::before {\n  transform: translateX(20px);\n}\n\n.bot-content-container {\n  padding: 8px 0;\n}\n\n\n/* Add these to appStyle.module.css */\n/* Add to appStyle.module.css */\n.dropdownSection {\n  margin-bottom: 20px;\n  width: 100%;\n}\n\n.dropdownHeader {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 0;\n  border-bottom: 1px solid #e0e0e0;\n  transition: all 0.3s ease;\n}\n\n.dropdownHeader:hover {\n  opacity: 0.8;\n}\n\n.dropdownContent {\n  animation: slideDown 0.3s ease;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.controlGroup {\n  margin-bottom: 10px;\n  padding: 15px;\n  background: #e6edff;\n  border-radius: 6px;\n  border: 1px solid #a3bdff;\n}\n\n.controlLabel {\n  display: flex;\n  flex-direction: column-reverse;\n}\n.disabledMessage {\n  margin: auto;\n  margin-bottom: 20px;\n}\n.labelText {\n  font-size: 16px;\n  font-weight: 600;\n  color: #0a0a0a;\n}\n\n.toggleLabel {\n  font-size: 14px;\n  color: #495057;\n  font-weight: 500;\n}\n\n.toggleSwitch {\n  width: 50px;\n  height: 24px;\n  background-color: #ccc;\n  border-radius: 12px;\n  position: relative;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.toggleOn {\n  background-color: var(--saveBtn);\n}\n\n.toggleOff {\n  background-color: #ccc;\n}\n\n.toggleSlider {\n  width: 20px;\n  height: 20px;\n  background-color: var(--white-color);\n  border-radius: 50%;\n  position: absolute;\n  top: 2px;\n  transition: transform 0.3s;\n}\n\n.toggleOn .toggleSlider {\n  transform: translateX(26px);\n}\n\n.toggleOff .toggleSlider {\n  transform: translateX(2px);\n}\n\n.helperText {\n  font-size: 13px;\n  color: #6c757d;\n  margin: 5px 0 0 0;\n  font-style: italic;\n}\n\n/* In your appStyle.module.css */\n.duplicate-url {\n  border: 2px solid #ffa500 !important;\n  background-color: #fff9e6 !important;\n}\n\n.duplicate-warning {\n  color: #ffa500;\n  font-size: 0.8rem;\n  font-style: italic;\n  margin-top: 4px;\n}\n\n.ingested-urls-list {\n  margin-top: 15px;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  padding: 15px;\n  background: #f8f9fa;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.ingested-urls-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.ingested-urls-header h5 {\n  margin: 0;\n  font-size: 14px;\n  color: #495057;\n  font-weight: 600;\n}\n\n.show-all-button {\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 4px 12px;\n  border-radius: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.show-all-button:hover {\n  background: #0056b3;\n}\n\n.ingested-urls-list ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.ingested-url-item {\n  display: flex;\n  align-items: flex-start;\n  padding: 8px 0;\n  border-bottom: 1px solid #e9ecef;\n  font-size: 13px;\n}\n\n.ingested-url-item:last-child {\n  border-bottom: none;\n}\n\n.url-number {\n  min-width: 20px;\n  color: #6c757d;\n  font-weight: 500;\n  margin-right: 8px;\n}\n\n.url-text {\n  word-break: break-all;\n  color: #495057;\n  line-height: 1.4;\n}\n\n.more-urls-indicator {\n  text-align: center;\n  padding: 8px;\n  color: #6c757d;\n  font-size: 12px;\n  font-style: italic;\n  background: #e9ecef;\n  border-radius: 4px;\n  margin-top: 8px;\n}\n\n/* Scrollbar styling for the URLs list */\n.ingested-urls-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.ingested-urls-list::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 3px;\n}\n\n.ingested-urls-list::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 3px;\n}\n\n.ingested-urls-list::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n.nested-toggle {\n  margin-bottom: 15px;\n  padding: 10px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border: 1px solid #e9ecef;\n}\n\n.nested-toggle label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.help-text {\n  display: block;\n  font-size: 12px;\n  color: #6c757d;\n  margin-top: 4px;\n  margin-left: 24px;\n}\n\n.ingested-urls-list {\n  margin-top: 15px;\n  max-height: 200px;\n  overflow-y: auto;\n  border: 1px solid #e9ecef;\n  border-radius: 6px;\n  padding: 10px;\n  background: #f8f9fa;\n}\n\n.ingested-urls-list h5 {\n  margin: 0 0 10px 0;\n  font-size: 14px;\n  color: #495057;\n}\n\n.ingested-urls-list ul {\n  margin: 0;\n  padding-left: 20px;\n}\n\n.ingested-urls-list li {\n  font-size: 12px;\n  word-break: break-all;\n  margin-bottom: 5px;\n  color: #6c757d;\n}\n/* \n.wrap_welcome_message {\n  width: 100%;\n  padding: 4px 0;\n  border-radius: 6px;\n  background: #d5e9ff;\n  border: 1px solid var(--primary);\n  padding: 20px;\n} */\n.wrap_welcome_message h3 {\n  margin: 0 0 20px 0;\n  color: var(--dark2-color);\n  font-size: 1rem;\n}\n.wrap_welcome_message p {\n  color: var(--heading);\n}\n.welcome_message {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: 20px;\n}\n.validationError {\n  border: 2px solid red !important;\n}\n\n/* Main container */\n.ai-agent-container {\n  /* max-width: 800px; */\n  margin: 20px auto;\n  padding: 20px;\n  font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", sans-serif;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  background-color: transparent;\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n}\n.headings {\n  font-size: 20px;\n  font-weight: 600;\n  color: #333;\n  margin: 0;\n  /* text-align: left; */\n}\n.ai-agent-container h3 {\n  margin-bottom: 20px;\n  color: #353232;\n}\n.ai-agent-container p {\n  color: #666;\n}\n\n/* Method toggles */\n.ingestion-methods {\n  display: flex;\n  gap: 20px;\n  margin: 30px auto;\n  align-items: center;\n  justify-content: center;\n}\n\n.method-toggle {\n  display: flex;\n  align-items: center;\n}\n\n.method-toggle label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.method-toggle input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n}\n\n/* Ingestion sections */\n.ingestion-sections {\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n  margin-bottom: 30px;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n}\n\n.ingestion-section {\n  border: 1px solid #e1e5e9;\n  padding: 20px;\n  border-radius: 8px;\n  background-color: #fafbfc;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 360px;\n  max-width: 530px;\n}\n\n.ingestion-section h4 {\n  margin: 0 0 15px 0;\n  color: #2d333a;\n}\n\n/* Input fields */\n.url-input,\n.file-input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 14px;\n  margin-bottom: 10px;\n}\n\n.url-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n/* URL management */\n.url-row {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 10px;\n  align-items: center;\n  width: 100%;\n}\n\n.url-row .url-input {\n  flex: 1;\n  margin-bottom: 0;\n}\n\n/* Buttons */\n.add-url-button,\n.remove-url-button,\n.ingest-all-button {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n.add-url-button {\n  background-color: #a370ce;\n  color: white;\n}\n\n.add-url-button:hover {\n  background-color: #8859af;\n}\n\n.remove-url-button {\n  background-color: #fee2e2;\n  color: #b91c1c;\n  padding: 6px 12px;\n}\n\n.remove-url-button:hover {\n  background-color: #fecaca;\n}\n\n.ingest-all-button {\n  padding: 10px 20px;\n  background-color: #28a745;\n  color: white;\n  font-size: 1rem;\n  border-radius: 6px;\n  border: none;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.ingest-all-button:hover:not(:disabled) {\n  background-color: #059669;\n}\n\n.ingest-all-button:disabled {\n  background-color: #9ca3af;\n  cursor: not-allowed;\n}\n\n/* File upload */\n.file-input {\n  display: none;\n}\n\n.file-input-label {\n  display: inline-block;\n  padding: 10px 16px;\n  background-color: #f3f4f6;\n  border: 1px dashed #6e6e6f;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.file-input-label:hover {\n  background-color: #e5e7eb;\n}\n.ingestion-section .file-input-label {\n  width: 100%;\n  max-width: 300px;\n  text-align: center;\n  color: #6e6e6f;\n}\n/* File list */\n.file-list {\n  margin-top: 15px;\n  border: 1px solid #bfbfbf;\n  padding: 20px;\n  border-radius: 8px;\n  background: white;\n  margin-top: 15px;\n}\n\n.file-list ul {\n  list-style: none;\n  padding: 0;\n  margin: 10px 0 0 0;\n}\n\n.file-list li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 0;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.remove-file-button {\n  background: none;\n  border: none;\n  color: #ef4444;\n  cursor: pointer;\n  font-size: 12px;\n  padding: 2px 6px;\n}\n\n/* Progress and messages */\n.progress {\n  color: #059669;\n  font-size: 14px;\n  margin-left: 10px;\n  margin-top: 15px;\n}\n\n.ingestion-message {\n  padding: 12px;\n  border-radius: 4px;\n  margin: 20px 0;\n  background-color: #fef3c7;\n  color: #92400e;\n  border: 1px solid #fcd34d;\n}\n\n.success-message {\n  color: #059669;\n  font-weight: 500;\n  margin: 20px 0;\n}\n\n/* Error states */\n.error-border {\n  border-color: #ef4444 !important;\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: white;\n  padding: 25px;\n  border-radius: 8px;\n  max-width: 500px;\n  width: 90%;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.modal h3 {\n  margin: 0 0 15px 0;\n  color: #2d333a;\n}\n\n.modal p {\n  margin: 0 0 20px 0;\n  color: #6b7280;\n}\n\n.modal-buttons {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.cancel-button,\n.confirm-button {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.cancel-button {\n  background-color: #f3f4f6;\n  color: #374151;\n}\n\n.cancel-button:hover {\n  background-color: #e5e7eb;\n}\n\n.confirm-button {\n  background-color: #ef4444;\n  color: white;\n}\n\n.confirm-button:hover {\n  background-color: #dc2626;\n}\n\n.mesgWrapper {\n  background-color: #e6edff;\n  border: 1px solid #a3bdff;\n  padding: 20px;\n  border-radius: 8px;\n  /* margin-top: 30px; */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.message_wrapper {\n  display: block;\n  width: 100%;\n}\n\n.message_input {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: column;\n}\n.actions_leftWord_wrap {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: row-reverse;\n  width: 100%;\n  margin-top: 5px;\n}\n/* .message_preview {\n  background-color: rgb(243, 243, 243);\n  width: 100%;\n  padding: 8px;\n  margin-top: 10px;\n  max-height: 110px;\n  overflow: auto;\n} */\n\n.message_preview p {\n  color: #00796b;\n  font-size: 16px;\n}\n\n.message_input_box {\n  width: 100%;\n  border: none;\n  border-bottom: 2px solid #e5e7eb;\n  outline: none;\n  padding: 5px 15px 15px 0;\n  font-size: 14px;\n  transition: border-color 0.3s ease;\n  color: #374151;\n}\n\n.message_input_box::placeholder {\n  color: #9ca3af;\n}\n\n.message_input_box:focus {\n  border-bottom: 2px solid var(--primary);\n  color: var(--text-color);\n}\n\n.sendMsg,\n.resetBtn,\n.skipBtn {\n  border-radius: 5px;\n  padding: 5px 10px;\n  outline: none;\n  background-color: transparent;\n  font-size: 16px;\n  border: none;\n  cursor: pointer;\n}\n.sendMsg {\n  background: var(--primary);\n  color: var(--white-color);\n}\n.sendMsg:hover {\n  background: var(--primary-hover);\n}\n.resetBtn {\n  background-color: var(--cancelBtn);\n  color: var(--heading);\n  margin-right: 10px;\n}\n\n/* AI Agent Ingestion Styles */\n.aiAgentContainer {\n  margin: 20px 0;\n  padding: 20px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  background-color: #f9f9f9;\n}\n\n.ingestionMethods {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n  margin-bottom: 20px;\n}\n\n.methodToggle {\n  display: flex;\n  align-items: center;\n}\n\n.methodToggle label {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.methodToggle input[type=\"checkbox\"] {\n  margin-right: 8px;\n}\n\n.ingestionSections {\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 15px;\n  margin-bottom: 20px;\n}\n\n.ingestionSection {\n  margin-bottom: 20px;\n  padding-bottom: 15px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.ingestionSection:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n}\n\n.ingestionSection h4 {\n  margin-top: 0;\n  margin-bottom: 10px;\n  color: #333;\n}\n\n.urlRow {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  gap: 10px;\n}\n\n.fileList {\n  margin-top: 15px;\n}\n\n.fileList ul {\n  list-style: none;\n  padding: 0;\n}\n\n.fileList li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px;\n  background-color: #f9f9f9;\n  border-radius: 4px;\n  margin-bottom: 8px;\n}\n\n.fileInputLabel {\n  display: block;\n  padding: 10px 15px;\n  background-color: #f0f0f0;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-bottom: 10px;\n  text-align: center;\n}\n\n.fileInputLabel:hover {\n  background-color: #e0e0e0;\n}\n\n.progress {\n  margin-left: 10px;\n  font-size: 0.9em;\n  color: #666;\n}\n\n.ingestAllButton {\n  background-color: var(--saveBtn);\n  color: var(--white-color);\n  border: none;\n  padding: 12px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background-color 0.3s;\n}\n\n.ingestAllButton:hover:not(:disabled) {\n  background-color: var(--saveHover);\n}\n\n.ingestAllButton:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.addUrlButton {\n  background-color: var(--saveBtn);\n  color: var(--white-color);\n}\n\n.removeUrlButton {\n  background-color: #dc3545;\n  color: white;\n}\n\n.ingestionMessage {\n  margin-top: 10px;\n  padding: 10px;\n  border-radius: 4px;\n  background-color: #e9ecef;\n}\n\n.toggleSection {\n  display: flex;\n  align-items: center;\n  margin: 15px 0;\n  gap: 10px;\n}\n\n.suggestion_icon {\n  color: #94a3b8;\n  font-size: 16px;\n  cursor: pointer;\n  transition: color 0.2s;\n  margin-left: 6px;\n}\n\n.suggestion_icon:hover {\n  color: #3b82f6;\n}\n\n.title_ic {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.title_ic h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #0a0a0a;\n}\n\n.botContent_sections {\n  margin-bottom: 30px;\n  padding: 15px;\n  background: #e6edff;\n  border-radius: 6px;\n  border: 1px solid #a3bdff;\n}\n.message_preview h4 {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: italic;\n  color: var(--dark-color);\n  text-align: center;\n  margin: 0 0 10px 0;\n}\n\n/* Toggle Switch Styles */\n.toggleSwitchContainer {\n  display: flex;\n  align-items: center;\n  /* margin-bottom: 15px; */\n}\n\n.toggleSwitch {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 24px;\n  margin-right: 10px;\n}\n\n.toggleSwitch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.info-message {\n  background-color: #e8f4fd;\n  border: 1px solid #b6e0fe;\n  border-radius: 4px;\n  padding: 8px 12px;\n  margin: 10px 0;\n  font-size: 14px;\n  color: #1e6fa3;\n}\n\n.toggleSwitch input:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\ninput:checked + .toggleSlider {\n  background-color: #2196f3;\n}\n\ninput:checked + .toggleSlider:before {\n  transform: translateX(26px);\n}\n\n.toggleLabel {\n  font-weight: 500;\n}\n\n.toggleWithLabel {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 15px;\n}\n\n.choose-option {\n  display: flex;\n  margin-bottom: 30px;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n}\n\n.choose-option label {\n  font-size: 24px;\n  font-weight: 600;\n  color: var(--dark2-color);\n  margin: 0;\n}\n.refreshButton {\n  margin-left: 10px;\n  font-size: 0.8rem;\n  background-color: var(--icon-bg-color);\n  border-radius: 50%;\n  cursor: pointer;\n  width: 30px;\n  height: 30px;\n  color: #3f82ff;\n  outline: none;\n  border: none;\n  font-size: 20px;\n}\n@media screen and (max-width: 1068px) {\n  .create_Container {\n    width: 95%;\n    height: auto;\n  }\n  .input-row {\n    padding: 14px 12px;\n    flex-wrap: wrap;\n  }\n  .input-row label {\n    flex-wrap: wrap;\n    justify-content: flex-start;\n  }\n  .input-row label strong,\n  .input-row label p {\n    white-space: normal;\n  }\n  .wrap_welcome_message {\n    flex-direction: column;\n  }\n}\n@media screen and (max-width: 360px) {\n  .ingestion-section {\n    width: 100%;\n    min-width: 0px;\n  }\n  .ingestion-methods {\n    flex-direction: column;\n    align-items: flex-start;\n    margin: 15px 0px;\n  }\n  .toggleWithLabel {\n    margin-bottom: 20px;\n  }\n  .welcome_message {\n    flex-direction: column;\n    padding: 0px;\n  }\n  .wrap_welcome_message {\n    padding: 10px;\n  }\n  .mesgWrapper {\n    padding: 10px;\n  }\n  .actions_leftWord_wrap {\n    flex-direction: column-reverse;\n    gap: 20px;\n    align-items: flex-start;\n  }\n  .message_preview {\n    text-align: left;\n  }\n  .message_preview p {\n    /* border: 1px solid red; */\n    font-size: 12px;\n  }\n}\n/* .toggleContainer {\n  display: flex;\n  width: 100%;\n  flex-direction: column-reverse;\n} */\n.titleSection {\n  /* flex: 1 1; */\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 8px;\n  /* text-align: center; */\n  flex-direction: column;\n  width: 100%;\n}\n\n.switch {\n  flex-shrink: 0;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 44px;\n  height: 24px;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n.toggleContainer .switchWrap {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  inset: 0;\n  background-color: #ccc;\n  transition: 0.3s;\n  border-radius: 24px;\n}\n\n.slider::before {\n  content: \"\";\n  position: absolute;\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.3s;\n  border-radius: 50%;\n}\n\n.switch input:checked + .slider {\n  background: var(--saveBtn);\n}\n\n.switch input:checked + .slider::before {\n  transform: translateX(20px);\n}\n\n.toggleText {\n  font-size: 14px;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputHeaderRow": `appStyle_inputHeaderRow__GZLhK`,
	"message_input_box": `appStyle_message_input_box__RqzO-`,
	"comingSoonBadge": `appStyle_comingSoonBadge__S-kF0`,
	"subtlePulse": `appStyle_subtlePulse__88Aae`,
	"resetBtn": `appStyle_resetBtn__1XXUh`,
	"sendMsg": `appStyle_sendMsg__Ava2G`,
	"modalOverlay": `appStyle_modalOverlay__VJenO`,
	"fadeIn": `appStyle_fadeIn__VC4-K`,
	"modal": `appStyle_modal__0bN8s`,
	"slideUp": `appStyle_slideUp__wjFRa`,
	"closeButton": `appStyle_closeButton__peMkR`,
	"modalContent": `appStyle_modalContent__GUE6E`,
	"suggestion_icon": `appStyle_suggestion_icon__41mtO`,
	"title_ic": `appStyle_title_ic__BAe+e`,
	"toggleContainer": `appStyle_toggleContainer__4vJu+`,
	"liveAgentToggle": `appStyle_liveAgentToggle__8psFe`,
	"toggleText": `appStyle_toggleText__ypSL7`,
	"switchWrap": `appStyle_switchWrap__oYyha`,
	"switch": `appStyle_switch__aM2cr`,
	"slider": `appStyle_slider__nMDhn`,
	"active": `appStyle_active__eNaNg`,
	"bot-content-container": `appStyle_bot-content-container__GUKBw`,
	"dropdownSection": `appStyle_dropdownSection__LHDar`,
	"dropdownHeader": `appStyle_dropdownHeader__8b4DP`,
	"dropdownContent": `appStyle_dropdownContent__guVYe`,
	"slideDown": `appStyle_slideDown__cPnXs`,
	"controlGroup": `appStyle_controlGroup__iHpRw`,
	"controlLabel": `appStyle_controlLabel__QM4aE`,
	"disabledMessage": `appStyle_disabledMessage__eYrgf`,
	"labelText": `appStyle_labelText__8yoW+`,
	"toggleLabel": `appStyle_toggleLabel__YuDOw`,
	"toggleSwitch": `appStyle_toggleSwitch__fymGA`,
	"toggleOn": `appStyle_toggleOn__qHQW+`,
	"toggleOff": `appStyle_toggleOff__ArqCq`,
	"toggleSlider": `appStyle_toggleSlider__qF98n`,
	"helperText": `appStyle_helperText__m9xcb`,
	"duplicate-url": `appStyle_duplicate-url__Of3gN`,
	"duplicate-warning": `appStyle_duplicate-warning__zogoz`,
	"ingested-urls-list": `appStyle_ingested-urls-list__cChkS`,
	"ingested-urls-header": `appStyle_ingested-urls-header__reFcl`,
	"show-all-button": `appStyle_show-all-button__vJEIZ`,
	"ingested-url-item": `appStyle_ingested-url-item__yPsX+`,
	"url-number": `appStyle_url-number__MKoaG`,
	"url-text": `appStyle_url-text__+GiPG`,
	"more-urls-indicator": `appStyle_more-urls-indicator__u1TNs`,
	"nested-toggle": `appStyle_nested-toggle__C+Ldx`,
	"help-text": `appStyle_help-text__wPUae`,
	"wrap_welcome_message": `appStyle_wrap_welcome_message__7aSpf`,
	"welcome_message": `appStyle_welcome_message__JOoR7`,
	"validationError": `appStyle_validationError__A7TzJ`,
	"ai-agent-container": `appStyle_ai-agent-container__qK0sI`,
	"headings": `appStyle_headings__gh9HX`,
	"ingestion-methods": `appStyle_ingestion-methods__8A5IF`,
	"method-toggle": `appStyle_method-toggle__rZBOg`,
	"ingestion-sections": `appStyle_ingestion-sections__5fP4q`,
	"ingestion-section": `appStyle_ingestion-section__hSWoM`,
	"url-input": `appStyle_url-input__trckO`,
	"file-input": `appStyle_file-input__-PqmL`,
	"url-row": `appStyle_url-row__Ggev2`,
	"add-url-button": `appStyle_add-url-button__dUIBx`,
	"remove-url-button": `appStyle_remove-url-button__hy8mV`,
	"ingest-all-button": `appStyle_ingest-all-button__45XSS`,
	"file-input-label": `appStyle_file-input-label__Lf+YU`,
	"file-list": `appStyle_file-list__TC9+C`,
	"remove-file-button": `appStyle_remove-file-button__lqUDP`,
	"progress": `appStyle_progress__Oy9+X`,
	"ingestion-message": `appStyle_ingestion-message__DoPNR`,
	"success-message": `appStyle_success-message__6XKPn`,
	"error-border": `appStyle_error-border__HInCw`,
	"modal-overlay": `appStyle_modal-overlay__zggQL`,
	"modal-buttons": `appStyle_modal-buttons__DbMm5`,
	"cancel-button": `appStyle_cancel-button__Y0jxm`,
	"confirm-button": `appStyle_confirm-button__XZKi3`,
	"mesgWrapper": `appStyle_mesgWrapper__ANtNq`,
	"message_wrapper": `appStyle_message_wrapper__32bB3`,
	"message_input": `appStyle_message_input__rDkoj`,
	"actions_leftWord_wrap": `appStyle_actions_leftWord_wrap__a5PI7`,
	"message_preview": `appStyle_message_preview__maJAX`,
	"skipBtn": `appStyle_skipBtn__Wq-dG`,
	"aiAgentContainer": `appStyle_aiAgentContainer__wqLU5`,
	"ingestionMethods": `appStyle_ingestionMethods__CIZmi`,
	"methodToggle": `appStyle_methodToggle__5eXUL`,
	"ingestionSections": `appStyle_ingestionSections__rzZWa`,
	"ingestionSection": `appStyle_ingestionSection__GJFHn`,
	"urlRow": `appStyle_urlRow__hGkMm`,
	"fileList": `appStyle_fileList__5w7BQ`,
	"fileInputLabel": `appStyle_fileInputLabel__PSUCs`,
	"ingestAllButton": `appStyle_ingestAllButton__yDGUA`,
	"addUrlButton": `appStyle_addUrlButton__0h6uW`,
	"removeUrlButton": `appStyle_removeUrlButton__ZsAcd`,
	"ingestionMessage": `appStyle_ingestionMessage__moULt`,
	"toggleSection": `appStyle_toggleSection__JIDxH`,
	"botContent_sections": `appStyle_botContent_sections__Ef0tp`,
	"toggleSwitchContainer": `appStyle_toggleSwitchContainer__qT7C5`,
	"info-message": `appStyle_info-message__4y5aY`,
	"toggleWithLabel": `appStyle_toggleWithLabel__Oe29r`,
	"choose-option": `appStyle_choose-option__3+Qmn`,
	"refreshButton": `appStyle_refreshButton__RXsJN`,
	"create_Container": `appStyle_create_Container__cUCq+`,
	"input-row": `appStyle_input-row__nyMrM`,
	"titleSection": `appStyle_titleSection__5L8mE`
};
export default ___CSS_LOADER_EXPORT___;
